/**
 * 支持的语言
 */
export default {
  en: 'English',
  // 'ru-RU': 'русский язык', // 俄语
  // fr: 'Français', // 法语
  // de: 'Deutsch', // 德语
  // pt: 'Português', // 葡萄牙语
  es: 'Español' // 西班牙语
  // 'zh-CN': '中文' // 中文

  // japanese: 'ja',
  // arabic: 'ar',
  // italian: 'it',
  // vietnam: 'vi',
  // turkey: 'tr-TR',
  // korean: 'ko',
  // thai: 'th',
  // dutch: 'nl',
  // hebrew: 'he',
  // indonesian: 'id'
}
